import state from './moduleReportingDashboardState.js';
import mutations from './moduleReportingDashboardMutations.js';
import actions from './moduleReportingDashboardActions.js';
import getters from './moduleReportingDashboardGetters.js';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
